const _excluded = ["filterType"];

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import digitalData from 'digital-data';
import { getState, setState } from '../analytics-state.js';
import { PRIMARY_FILTER } from '../constants.js';
import { getFilters } from '../thd-analytics-utils.js';
export const getPageInfoFilters = arr => {
  let appliedFilters = [];
  arr.forEach((item, index) => {
    item = item.map(_ref => {
      let {
          filterType
        } = _ref,
        rest = _objectWithoutProperties(_ref, _excluded);
      return _objectSpread({}, rest);
    });
    appliedFilters.push(item);
  });
  return appliedFilters;
};
export const processFilters = (newLayout, filterType) => {
  var _newLayout$output;
  const state = getState();
  const {
    pageType,
    currentPage,
    sortBy
  } = state || {};
  let finalSelectedFilters = [];
  digitalData.event = digitalData.event || [];
  digitalData.page = digitalData.page || [];

  // Setting pageTransitionEvent as PRIMARY_FILTER, ReInitAnalytics won't trigger
  setState(_objectSpread(_objectSpread({}, getState()), {}, {
    pageTransitionEvent: PRIMARY_FILTER
  }));

  // Find all pre-selected filters, if present
  let lastevent = digitalData.event[digitalData.event.findLastIndex(item => item.hasOwnProperty('filter'))];

  // Check if Clear All btn is clicked
  if (!(newLayout !== null && newLayout !== void 0 && (_newLayout$output = newLayout.output) !== null && _newLayout$output !== void 0 && _newLayout$output.clear)) {
    if (lastevent && lastevent.filter) {
      var _newLayout$output2;
      // loop through the event passed args
      newLayout === null || newLayout === void 0 ? void 0 : (_newLayout$output2 = newLayout.output) === null || _newLayout$output2 === void 0 ? void 0 : _newLayout$output2.forEach(function () {
        var _newLayout$output3, _newLayout$output3$in;
        let filterIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let indexf = arguments.length > 1 ? arguments[1] : undefined;
        const selectedFilters = [];
        newLayout === null || newLayout === void 0 ? void 0 : (_newLayout$output3 = newLayout.output) === null || _newLayout$output3 === void 0 ? void 0 : (_newLayout$output3$in = _newLayout$output3[indexf]) === null || _newLayout$output3$in === void 0 ? void 0 : _newLayout$output3$in.refinements.forEach(function () {
          let crumb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          let index = arguments.length > 1 ? arguments[1] : undefined;
          // compare lastevent(previous selected filters) and current event(new filters)
          // If the filter already present in lastevent then push the same
          // otherwise create new with given filterType for new event
          let _rowItem;
          lastevent.filter.map(arr => arr.map(item => {
            if (item.value === (crumb === null || crumb === void 0 ? void 0 : crumb.label)) return _rowItem = item;
          }));
          if (_rowItem) {
            selectedFilters.push(_rowItem);
          } else {
            var _newLayout$output4;
            selectedFilters.push({
              type: newLayout === null || newLayout === void 0 ? void 0 : (_newLayout$output4 = newLayout.output) === null || _newLayout$output4 === void 0 ? void 0 : _newLayout$output4[indexf].label,
              value: crumb === null || crumb === void 0 ? void 0 : crumb.label,
              filterType
            });
          }
        });
        // append the new filters into previous selected filters
        finalSelectedFilters.push(selectedFilters);
      });
    } else {
      var _newLayout$output5;
      // If first filter selection is done
      newLayout === null || newLayout === void 0 ? void 0 : (_newLayout$output5 = newLayout.output) === null || _newLayout$output5 === void 0 ? void 0 : _newLayout$output5.forEach(function () {
        var _newLayout$output6, _newLayout$output6$in;
        let filterIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        let indexf = arguments.length > 1 ? arguments[1] : undefined;
        const selectedFilters = [];
        newLayout === null || newLayout === void 0 ? void 0 : (_newLayout$output6 = newLayout.output) === null || _newLayout$output6 === void 0 ? void 0 : (_newLayout$output6$in = _newLayout$output6[indexf]) === null || _newLayout$output6$in === void 0 ? void 0 : _newLayout$output6$in.refinements.forEach(function () {
          var _newLayout$output7;
          let crumb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          let index = arguments.length > 1 ? arguments[1] : undefined;
          if (!(crumb !== null && crumb !== void 0 && crumb.label)) return;
          selectedFilters.push({
            type: newLayout === null || newLayout === void 0 ? void 0 : (_newLayout$output7 = newLayout.output) === null || _newLayout$output7 === void 0 ? void 0 : _newLayout$output7[indexf].label,
            value: crumb === null || crumb === void 0 ? void 0 : crumb.label,
            filterType
          });
        });
        finalSelectedFilters.push(selectedFilters);
      });
    }
  }
  digitalData.event.push({
    category: {
      primaryCategory: pageType || ''
    },
    eventInfo: {
      eventName: 'filter By'
    },
    displayAttributes: {
      pageNumber: currentPage || 0,
      productsAvailabilty: 'all products',
      sortBy: sortBy || 'bestmatch',
      viewType: 'grid'
    },
    filter: finalSelectedFilters
  });
  digitalData.page.filter = finalSelectedFilters.length ? getPageInfoFilters(finalSelectedFilters) : getFilters(finalSelectedFilters);
  // update state with addition/removal of filters
  setState(_objectSpread(_objectSpread({}, getState()), {}, {
    filters: finalSelectedFilters
  }));
};

/* Format and arrange the refinements passed down
 into new data structure i.e Arrays of arrays */
export const transformArray = input => {
  const result = [];

  // A helper object to group items by dimension
  const groups = {};

  // Process each array in the input
  input.forEach(subArray => {
    subArray.forEach(item => {
      const dimensionName = item.type || item.dimensionName;
      const label = item.value || item.label;
      if (!groups[dimensionName]) {
        groups[dimensionName] = [];
      }
      groups[dimensionName].push({
        dimensionName,
        label
      });
    });
  });

  // Convert grouped items into the required output format
  for (const [dimensionName, items] of Object.entries(groups)) {
    result.push({
      label: dimensionName,
      refinements: items
    });
  }
  return result;
};
export const updateFilters = (filters, output) => {
  const {
    dimensionName,
    label,
    selected
  } = output;

  // Find the group that matches the output's dimensionName
  const group = filters.find(group => group.some(filter => filter.type === dimensionName || filter.dimensionName === dimensionName));
  if (selected === null) {
    // Add the filter to the group or create a new group if it doesn't exist
    group ? group.push(_objectSpread({}, output)) : filters.push([_objectSpread({}, output)]);
  } else if (group) {
    // Remove the filter from the group
    group.splice(group.findIndex(filter => filter.value === label), 1);
    // Remove the group if empty
    if (!group.length) filters.splice(filters.indexOf(group), 1);
  }
  return filters;
};
export const formatFilters = newLayout => {
  let {
    filters = []
  } = getState();
  let {
    output = {}
  } = newLayout;
  if (output !== null && output !== void 0 && output.clear) {
    filters = [];
  } else if (output !== null && output !== void 0 && output.dimensionName) {
    filters = updateFilters(filters, output);
  }
  newLayout.output = transformArray(filters);
  processFilters(newLayout, 'others');
};
export const primaryFilters = () => {
  // when user selects from primary filters
  window.LIFE_CYCLE_EVENT_BUS.on('product-results.change-filters-refinements', function () {
    let newLayout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    processFilters(newLayout, 'primary');
  });

  // when user selects from secondary filters
  window.LIFE_CYCLE_EVENT_BUS.on('product-results.change-filters-refinements-secondary', function () {
    let newLayout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    processFilters(newLayout, 'secondary');
  });

  // when user removes any one filters from chips
  window.LIFE_CYCLE_EVENT_BUS.on('product-results.change-filters-refinements-shortings', function () {
    let newLayout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    processFilters(newLayout, 'secondary');
  });

  // when user clicks on clear all (removes all filters from chips)
  window.LIFE_CYCLE_EVENT_BUS.on('product-results.change-filters-refinements-clear-all', function () {
    let newLayout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    processFilters(newLayout, 'clearAllFilters');
  });

  // when user selects from visual-Nav (getItFast filters)
  window.LIFE_CYCLE_EVENT_BUS.on('filters-refinements-visualNav.click', function () {
    let newLayout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    formatFilters(newLayout);
  });
};
//# sourceMappingURL=primary-filters.listener.analytics.js.map